export default "__VITE_ASSET__CKx6AIt7__"